import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Select } from '@ngxs/store';
import { TextMaskConfig } from 'angular2-text-mask';
import { Observable } from 'rxjs';
import { formatPhoneNumber } from 'src/shared/utils/phone-formatter.utils';

import { featuresWithPermissions } from '../../../data/permissions';
import { BasicInputTypeEnum } from '../../../enums/basic-input-type.enum';
import { EntityTypeEnum } from '../../../enums/entity-type.enum';
import { IQuestionChoices } from '../../../interfaces/radio-checkbox-config.interface';
import { IUser } from '../../../interfaces/users/user.interface';
import { AuthState } from '../../../store/state/auth.state';
import { EnumsState } from '../../../store/state/enums.state';
import { SchoolYearState } from '../../../store/state/school-year.state';

@Component({
    selector: 'app-general-data',
    templateUrl: './general-data.component.html',
    styleUrls: ['./general-data.component.scss'],
})
export class GeneralDataComponent {
    @Select(AuthState.currentUser) public currentUser$: Observable<IUser>;
    @Select(SchoolYearState.schoolYears) public schoolYears$: Observable<IQuestionChoices[]>;
    @Select(EnumsState.classTypes) public classTypesChoices$: Observable<IQuestionChoices[]>;

    @Select(EnumsState.educationTypes) public educationTypesEnum$: Observable<IQuestionChoices[]>;
    @Select(EnumsState.educationLevels) public educationLevelsEnum$: Observable<IQuestionChoices[]>;

    @Input() public formGroup: FormGroup;
    @Input() public isEdit: boolean;
    @Input() public entityType: string;
    @Input() public readonly: boolean;

    @Output() public elementSizeModification = new EventEmitter<void>();

    public entityTypeEnum = EntityTypeEnum;
    public basicInputTypeEnum = BasicInputTypeEnum;

    public bankAccountMaskConfig: TextMaskConfig = {
        mask: ['B', 'E', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
        guide: false,
    };

    public vatMaskConfig: TextMaskConfig = {
        mask: ['B', 'E', ' ', /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/],
        guide: false,
    };

    public permissions = featuresWithPermissions;

    public formatPhoneNumber(phoneNumber: FormControl): void {
        if (phoneNumber.valid) {
            phoneNumber.patchValue(formatPhoneNumber(phoneNumber.value));
        }
    }

    public get userType(): string {
        return this.formGroup.get('type').value;
    }

    public get educationType(): FormControl {
        return this.formGroup.get('educationType') as FormControl;
    }

    public get educationLevel(): FormControl {
        return this.formGroup.get('educationLevel') as FormControl;
    }

    public get name(): FormControl {
        return this.formGroup.get('name') as FormControl;
    }

    public get email(): FormControl {
        return this.formGroup.get('email') as FormControl;
    }

    public get mobileNumber(): FormControl {
        return this.formGroup.get('mobileNumber') as FormControl;
    }

    public get homeNumber(): FormControl {
        return this.formGroup.get('homeNumber') as FormControl;
    }

    public get website(): FormControl {
        return this.formGroup.get('website') as FormControl;
    }

    public get vatNumber(): FormControl {
        return this.formGroup.get('vatNumber') as FormControl;
    }

    public get bankAccount(): FormControl {
        return this.formGroup.get('bankAccount') as FormControl;
    }

    public get classType(): FormControl {
        return this.formGroup.get('classType') as FormControl;
    }

    public get schoolYear(): FormControl {
        return this.formGroup.get('schoolYear') as FormControl;
    }

    public get isActive(): FormControl {
        return this.formGroup.get('isActive') as FormControl;
    }
}
